import moment from 'moment';
import { Moment } from 'moment/moment';

import ISelectDatepicker from './SelectDatepicker';

export const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const monthList = () =>
  Array.apply(0, Array(12)).map(function (_, i) {
    return moment().month(i).format('MMMM');
  });

export const yearList = (minDate: string) => {
  const minDateMoment = moment(minDate);
  const currentDateMoment = moment(new Date());
  const diff = minDateMoment.diff(currentDateMoment, 'years');
  return Array.from(
    {
      length: diff ? -diff + 1 : minDateMoment.year() - (minDateMoment.year() - 16) + 1,
    },
    (_, index) => {
      return minDateMoment.year() + index;
    },
  );
};

export function getDayListForMonth(
  dateSelected: Moment,
): Record<number, ISelectDatepicker.IDayList> {
  const dayList: Record<number, ISelectDatepicker.IDayList> = {};
  const year = dateSelected.year();
  const month = dateSelected.month();
  let date = moment([year, month, 1]);

  while (date.month() === month) {
    const dayName = date.format('ddd');
    const dayNumber = date.date();
    const dayWeek = date.isoWeek();

    if (!dayList[dayWeek]) {
      dayList[dayWeek] = {};
    }

    dayList[dayWeek][dayName] = dayNumber;

    date.add(1, 'days');
  }

  return dayList;
}

export const weekdayList = () => {
  const abbreviatedWeekdays = moment.weekdaysShort();
  const startIndex = abbreviatedWeekdays.indexOf('Mon');
  return [...abbreviatedWeekdays.slice(startIndex), ...abbreviatedWeekdays.slice(0, startIndex)];
};
